import slugify from 'slugify';

export const normalizeMediaSlug = (value: string) => {
    return slugify(value.replace(/_/g, ' '), {
        lower: true,
        locale: 'fr',
        strict: true,
        trim: true,
    });
};

export const createMediaSlug = (title: string, fallback = 'media') => {
    return normalizeMediaSlug(title) || fallback;
};

export const createPhotoSlug = (value: string, fallback = 'photo') => {
    const slug = normalizeMediaSlug(value);
    if(/^\d+$/.test(slug)) return `photo-${slug}`;
    return slug || fallback;
};

export const createVideoSlug = (value: string, fallback = 'video') => {
    const slug = normalizeMediaSlug(value);
    if(/^\d+$/.test(slug)) return `video-${slug}`;
    return slug || fallback;
};
